export default {
  // 路由国际化
  route: {
    dashboard: '首页',
    document: '项目文档'
  },
  // 登录页面国际化
  login: {
    username: '用户名',
    password: '密码',
    login: '登 录',
    code: '请输入验证码',
    copyright: ''
  },
  navbar: {
    full: '全屏',
    language: '语言',
    dashboard: '首页',
    document: '项目文档',
    message: '消息',
    layoutSize: '布局大小',
    selectTenant: '选择租户',
    layoutSetting: '布局设置',
    personalCenter: '个人中心',
    logout: '退出登录'
  },
  footer: {
    officialSite: "官网首页",
    deviceShare: "共享平台",
    techConsult: "科技咨询",
    home: "首页",
    signin: "登录",
    quit: "退出",
    register: "注册",
    shoppingcart: "我的订单"
  },
  bottom: {
    p2: " 福建省福州市鼓楼区琴亭路29号方圆大厦1层",
    p3: " 350003",
    p4: " cxyjy@fjpec.com.cn",
    p5: " Copyright © 2024福建省能源石化创新研究院有限责任公司版权所有 闽ICP备2024055700号-1"
  },
}
